export const NOMINEE_AUTHENTICATION_LINK = "https://digital.camsonline.com/changeofnomination"